import { Button, Col, Input, Select, Row } from "antd";
import { useNavigate } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";

export const CustomerFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setShowModal,
  selectedRowKeys,
  setFilter,
}) => {
  const navigate = useNavigate();
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/accounts/options/`;
  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);

  const modifiedDealer = getModifiedResponse(optionsData, "dealers");
  const modifiedType = getModifiedResponse(optionsData, "roles");
  const modifiedOems = getModifiedResponse(optionsData, "oems");
  const logData = JSON.parse(sessionStorage.getItem("userData"));

  const onSearch = (value) => {
    console.log("search:", value);
  };

  return (
    <div className="mb-4">
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10"
              name="CustomerNo"
              placeholder="No"
              value={filter.CustomerNo}
              onChange={handleFilterChange}
            />
          </Col> */}
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              name="CustomerName"
              placeholder="Name"
              value={filter.CustomerName}
              onChange={handleFilterChange}
            />
          </Col>
          {![4, 5, 6, 7, 8, 9].includes(logData?.role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="OEM"
                optionFilterProp="OemNo"
                value={
                  filter.OemNo || typeof filter.OemNo === "number"
                    ? Number(filter.OemNo)
                    : null
                }
                onChange={(value) => setFilter({ ...filter, OemNo: value })}
                onSearch={onSearch}
                options={modifiedOems}
                style={{ width: "100%" }}
                allowClear
              />
            </Col>
          )}
          {![7, 8, 9].includes(logData?.role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Dealer"
                optionFilterProp="DealerNo"
                value={
                  filter.DealerNo || typeof filter.DealerNo === "number"
                    ? Number(filter.DealerNo)
                    : null
                }
                onChange={(value) => setFilter({ ...filter, DealerNo: value })}
                onSearch={onSearch}
                options={modifiedDealer}
                style={{ width: "100%" }}
                allowClear
              />
            </Col>
          )}
        </Row>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="flex items-center mt-4 flex-nowrap min-w-[610px]">
          <Button
            type="primary"
            className="mr-2 w-[104px] h-[30px] font-medium"
            onClick={handleFilter}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            Apply
          </Button>
          <Button className="reset-button" onClick={handleReset}>
            <HiArrowPath className="!text-[14px] font-medium" />
            Reset
          </Button>
          <Button
            type="primary"
            className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
            onClick={() => navigate("/customer/add")}
          >
            <PlusOutlined />
            Add
          </Button>
          <Button
            type="primary"
            disabled={selectedRowKeys?.length === 0 ? true : false}
            className="mr-2 w-[104px] h-[30px] font-medium"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <DeleteOutlined />
            Delete
          </Button>
          {/* <div>
            <Button
              type="primary"
              className="mr-2 w-[30px] h-[30px]"
              onClick={() => navigate("/customer/add")}
            >
              <PlusOutlined />
            </Button>
            <Button
              type="primary"
              disabled={selectedRowKeys?.length === 0 ? true : false}
              className="w-[30px] h-[30px]"
              onClick={() => {
                setShowModal(true);
              }}
            >
              <DeleteOutlined />
            </Button>
          </div> */}
        </div>
      </div>
    </div>
  );
};
